import { mapState, mapActions } from 'pinia'
import formatPhone from 'src/functions/formatPhone'
import {
  useLpuDataStore,
  useClubDataStore,
  useUserDataStore,
  useGlobalDataStore,
  useDoctorDataStore,
  useServiceDataStore,
  useCalendarDataStore,
  useAuthorizationStore, // todo(useAuthMt) - удалить
  useAppointmentDataStore,
  usePreliminaryConsultationStore,
} from 'www/vue_components/common/AppointmentPage/stores'

import {
  useDoctorAutomaticScheduleChecks,
} from 'www/vue_components/common/AppointmentPage/subStores'

/**
 * В данном миксине происходит слияние данных Pinia-хранилища (store)
 * и входных данных (props) главного компонента
 */

const AppointmentPageMergedProps = {
  computed: {
    ...mapState(useAuthorizationStore, [ // todo(useAuthMt) - удалить
      'userPhone', // todo(useAuthMt) - удалить
    ]),
    ...mapState(useAppointmentDataStore, [
      'appointmentPlaceTypes',
    ]),
  },
  created() {
    this.mergePropsWithStore()
  },
  methods: {
    mergePropsWithStore() {
      const clubDataStore = useClubDataStore()
      const lpuDataStore = useLpuDataStore()
      const globalDataStore = useGlobalDataStore()
      const doctorDataStore = useDoctorDataStore()
      const serviceDataStore = useServiceDataStore()
      const calendarDataStore = useCalendarDataStore()
      const authorizationStore = useAuthorizationStore() // todo(useAuthMt) - удалить
      const appointmentDataStore = useAppointmentDataStore()
      const preliminaryConsultationStore = usePreliminaryConsultationStore()
      const doctorAutomaticScheduleChecks = useDoctorAutomaticScheduleChecks()

      doctorAutomaticScheduleChecks.customRequestLimit = this.initCalendarData.customRequestLimit

      if (appointmentDataStore.useAuthMt) {
        const userDataStore = useUserDataStore()

        userDataStore.userPhone = this.initUserData.phone
      } else if (this.initUserData.phone) {
        authorizationStore.userPhone = this.initUserData.phone
      }

      this.lpuData.phone = formatPhone({
        phone: this.lpuData.phone,
        country: { iso: window.COUNTRY_DATA.iso },
      })

      lpuDataStore.lpuData = this.lpuData

      serviceDataStore.serviceData = this.serviceData
      serviceDataStore.equipmentsData = this.equipmentsData

      doctorDataStore.doctorsData = this.doctorsData
      doctorDataStore.doctorData = this.doctorData

      calendarDataStore.initCalendarData = this.initCalendarData

      appointmentDataStore.appointmentRegistrationTypes = this.appointmentRegistrationTypes
      appointmentDataStore.appointmentObjectTypes = this.appointmentObjectTypes
      appointmentDataStore.appointmentCallTimes = this.appointmentCallTimes
      appointmentDataStore.initAdditionalData = this.initAdditionalData

      globalDataStore.urls = this.urls

      clubDataStore.clubStatusData = this.initClubStatusData

      const {
        isPreliminaryConsultation,
        initConsultingDoctorsData,
        initDoctorsConsultationsData,
      } = this.initPreliminaryConsultationData

      appointmentDataStore.isAppointmentByReferral = this.isAppointmentByReferral

      preliminaryConsultationStore.isPreliminaryConsultation = isPreliminaryConsultation
      preliminaryConsultationStore.initConsultingDoctorsData = initConsultingDoctorsData
      preliminaryConsultationStore.initDoctorsConsultationsData = initDoctorsConsultationsData

      /** Далее логика, которая связана с успешной/неудачной записью на прием */

      if (this.initAppointmentStatusData.isError) {
        this.updateErrorData({
          isEnabled: true,
          title: this.initAppointmentStatusData.title,
          subtitle: this.initAppointmentStatusData.subtitle,
          buttonState: this.initAppointmentStatusData.buttonState,
        })
      } else if (this.initAppointmentStatusData.isSuccess) {
        this.updateSuccessData({
          isDialogRender: false,
          isEnabled: true,
          title: this.initAppointmentStatusData.title,
          subtitle: this.initAppointmentStatusData.subtitle,
          buttonState: this.initAppointmentStatusData.buttonState,
          medtochkaUrl: this.initAppointmentStatusData.medtochkaUrl,
          isEnableMedtochkaRedirect: this.initAppointmentStatusData.isEnableMedtochkaRedirect,
          showPhone: this.initAppointmentStatusData.code === 'has_recent_appointment_call',
        })
      }
    },
    ...mapActions(useGlobalDataStore, [
      'updateErrorData',
      'updateSuccessData',
    ]),
  },
}

export default AppointmentPageMergedProps
